import React from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { AiOutlineTeam, AiOutlinePieChart, AiOutlineProject, AiOutlineSafety, AiOutlineFund } from "react-icons/ai";
import DoughnutCharts from "./tokonomicsChart";


function Tokenomics() {

  return (
    <>
    <Container >
      <Row>
        <Col >
          <Row >
            <Col>
            <DoughnutCharts/>
            <Row>
              <Col>
              <div className="p-4 fs-7 ">
                <span className="text-teal198 me-lg-3">LP - Liquidity Pool.</span>
                <span className="text-teal198">RR - Realityverse Rewards Pool</span>

              </div>
              </Col>
            </Row>
            </Col>
          </Row>
          <Row >
            <div className="w-100 border-top border-dark"></div>
            <div className="col mt-5">
              <div className="mb-2">
                <span className="card-title-sub text-teal100 fs-9">Token Allocation (Max Supply: 6 Billion)</span>
              </div>
              <Row className="align-items-stretch">
                <Col xs={12} md className="tokenomics-col-gap d-flex">
                  <div className="card br-teal101 bg-transparent mb-5 tokenomics-card flex-fill h-100">
                    <div className="card-body d-flex flex-column align-items-center h-100 justify-content-center">
                      <AiOutlinePieChart className="tokenomics-icon" />
                      <div className="item-label">Presale</div>
                      <div className="item-value tokenomics-value">25%</div>
                      <div className="item-tokens">1,500,000,000</div>
                    </div>
                  </div>
                </Col>
               {/*  <Col xs={12} md className="tokenomics-col-gap">
                  <div className="card br-teal101 bg-transparent mb-5 tokenomics-card">
                    <div className="card-body d-flex flex-column align-items-center">
                      <AiOutlineDollar className="tokenomics-icon" />
                      <div className="item-label">Project Sale</div>
                      <div className="item-value tokenomics-value">11%</div>
                      <div className="item-tokens">660,000,000</div>
                    </div>
                  </div>
                </Col> */}
                <Col xs={12} md className="tokenomics-col-gap d-flex">
                  <div className="card br-teal101 bg-transparent mb-5 tokenomics-card flex-fill h-100">
                    <div className="card-body d-flex flex-column align-items-center h-100 justify-content-center">
                      <AiOutlineProject className="tokenomics-icon" />
                      <div className="item-label">Public Sale</div>
                      <div className="item-value tokenomics-value">17%</div>
                      <div className="item-tokens">1,020,000,000</div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md className="tokenomics-col-gap d-flex">
                  <div className="card br-teal101 bg-transparent mb-5 tokenomics-card flex-fill h-100">
                    <div className="card-body d-flex flex-column align-items-center h-100 justify-content-center">
                      <AiOutlineSafety className="tokenomics-icon" />
                      <div className="item-label">Liquidity Pool</div>
                      <div className="item-value tokenomics-value">25%</div>
                      <div className="item-tokens">1,500,000,000</div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md className="tokenomics-col-gap d-flex">
                  <div className="card br-teal101 bg-transparent mb-5 tokenomics-card flex-fill h-100">
                    <div className="card-body d-flex flex-column align-items-center h-100 justify-content-center">
                      <AiOutlineFund className="tokenomics-icon" />
                      <div className="item-label">Projects Pool</div>
                      <div className="item-value tokenomics-value">28%</div>
                      <div className="item-tokens">1,680,000,000</div>
                      <span className="small text-secondary d-block mt-1">Time Locked/Vested-on-Request</span>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md className="tokenomics-col-gap d-flex">
                  <div className="card br-teal101 bg-transparent mb-5 tokenomics-card flex-fill h-100">
                    <div className="card-body d-flex flex-column align-items-center h-100 justify-content-center">
                      <AiOutlineTeam className="tokenomics-icon team-icon" />
                      <div className="item-label ">Team Allocation</div>
                      <div className="item-value tokenomics-value">5%</div>
                      <div className="item-tokens ">300,000,000</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Row>
               <Row>
            <div className="col mt-5">
              <div className="mb-2">
                <span className="card-title-sub text-teal100 fs-9">Tax Distribution</span>
              </div>
              <Stack gap={3} className="tax-breakdown-stack">
                <Row className="g-4">
                  <Col md={6} lg={4}>
                    <div className="card taxD-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon bg-success mb-2">30%</div>
                        <h5 className="card-title mb-1">Bonus Pool</h5>
                        <p className="card-text mb-0 text-dark">USD 100,000 bonus giveaway, rewarding top traders and incentivizing active participation.</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div className="card taxD-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon bg-info mb-2">20%</div>
                        <h5 className="card-title mb-1">Rewards</h5>
                        <p className="card-text mb-0 text-dark">Ensures smooth trading of Reality Rewards points to physical items from the marketplace.</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div className="card taxD-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon bg-warning mb-2">10%</div>
                        <h5 className="card-title mb-1">Sovereign Chest</h5>
                        <p className="card-text mb-0 text-dark">Locked/Vested periodically to convert to stable coins and other assets to be used as support in market volatile periods.</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div className="card taxD-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon bg-primary mb-2">25%</div>
                        <h5 className="card-title mb-1">Development</h5>
                        <p className="card-text mb-0 text-dark">Supports development of the FONTANA ecosystem, platform maintenance, and upgrades.</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div className="card taxD-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon bg-danger mb-2">10%</div>
                        <h5 className="card-title mb-1">Burn</h5>
                        <p className="card-text mb-0 text-dark">Burning tokens until total supply is 5 billion or less. Removes 1 billion tokens.</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div className="card taxD-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon bg-success mb-2">5%</div>
                        <h5 className="card-title mb-1">Cerulean Vault</h5>
                        <p className="card-text mb-0 text-dark">Locked from supply. Funds Cerulean token programmatic buyback.</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Stack>
            </div>
          </Row>
          <Row>
            <div className="col mt-5">
              <div className="mb-2">
                <span className="card-title-sub text-yellow150 fs-9">Tax Breakdown</span>
              </div>
              <Stack gap={3} className="tax-breakdown-stack">
                <Row className="g-4">
                  <Col md={6} >
                    <div className="card tax-breakdown-card border-0 shadow-sm ">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon buy mb-2">1%</div>
                        <h5 className="card-title mb-1">Buy Tax</h5>
                        <p className="card-text mb-0 text-dark">Unlimited</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="card tax-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon sell mb-2">2%</div>
                        <h5 className="card-title mb-1">Sell Tax</h5>
                        <p className="card-text mb-0 text-dark">Upto DAV Threshold</p>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="g-4">
                  <Col md={6}>
                    <div className="card tax-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon svt mb-2">5%</div>
                        <h5 className="card-title mb-1">SVT Tax</h5>
                        <p className="card-text mb-0 text-dark">If 11% SVT is breached. Monitor 3 minute window. Reset after 60 seconds.
                          </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="card tax-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon dump mb-2">5%</div>
                        <h5 className="card-title mb-1">Price Drop</h5>
                        <p className="card-text mb-0 text-dark"> If price drop is more than 10% in a block or in a single 
                          transaction a 60 second tax bracket. </p>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="g-4">
                  <Col>
                    <div className="card tax-breakdown-card border-0 shadow-sm">
                      <div className="card-body d-flex flex-column align-items-center text-center">
                        <div className="tax-card-icon cex mb-2">25%</div>
                        <h5 className="card-title mb-1">CEX Integration & Liquidity Protection</h5>
                        <p className="card-text mb-0 text-dark">All outbound transfers to CEX wallets are subject to Dump Tax. Ensures stability and value retention during CEX expansion.</p>
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="text-secondary small">SVT - Sell Velocity Threshold. Sell volume below 
                  500K is not subjected to 5% tax.</div>
              </Stack>
            </div>
          </Row>
     
       
        </Col>
      </Row>
      

     
       







    
    </Container>
    
    
    </>
  );
}

export default Tokenomics;
